module.exports = __webpack_public_path__ + "2acb60f2/img/trash-icon.ff8201c7.svg";